export default __webpack_public_path__ + "static/media/vip_banner.c995bc58.jpg";